export default class Perfil {
  constructor(id, nome) {
    this.id = id
    this.nome = nome
  }
}
